import { Link } from "react-router-dom";

interface DisclosureProps {
  variant?: "default" | "compact";
}

export default function Disclosure({ variant = "default" }: DisclosureProps) {
  if (variant === "compact") {
    return (
      <p className="disclosure">
        <strong className="font-sans uppercase tracking-wider text-xs">
          Disclosure —
        </strong>{" "}
        Spain Smile Guide is affiliated with ACE DNTL GROUP. Our rubric is
        grounded in mainstream cosmetic-dentistry principles and applied
        identically to every clinic covered.{" "}
        <Link to="/methodology">See our methodology.</Link>
      </p>
    );
  }

  return (
    <aside className="disclosure" aria-label="Editorial disclosure">
      <div className="eyebrow mb-2">Editorial disclosure</div>
      <p className="text-small leading-relaxed text-ink">
        Spain Smile Guide is an editorial publication affiliated with ACE DNTL
        GROUP, a cosmetic-dentistry group based in Marbella. Our evaluation
        rubric is grounded in mainstream clinical and aesthetic principles
        used across modern cosmetic dentistry — principles that also inform
        Dr. Ace Korkchi&apos;s practice and the published ACE Smile
        Index&trade;. We apply the rubric identically to every clinic covered.
        We do not accept paid placement. We do not accept gifted consultations.
        We do not rank. We describe. The full rubric is published on our{" "}
        <Link to="/methodology">methodology page</Link>. Where ACE DNTL does
        not lead on a dimension, we say so.
      </p>
    </aside>
  );
}
